// main tools
import { useCallback } from 'react'

// bootstrap components
import { OverlayTrigger, Tooltip as BsTooltip } from 'react-bootstrap'

// styles
import classes from './styles.module.scss'

// type
import type { Placement } from 'react-bootstrap/esm/types'
import type { FC, ReactNode } from 'react'

export type TooltipProps = {
  copy?: boolean
  tooltip: string
  className?: string
  children: ReactNode
  placement?: Placement
}

export const Tooltip: FC<TooltipProps> = ({
  copy,
  tooltip,
  children,
  className = '',
  placement = 'bottom'
}) => {
  const OverlayTooltip = (
    <BsTooltip className={classes.tooltip}>{tooltip}</BsTooltip>
  )
  const handleCopy = async () => await navigator.clipboard.writeText(tooltip)

  const Wrapper = useCallback(
    ({ children }: { children: ReactNode }) =>
      tooltip ? (
        <OverlayTrigger placement={placement} overlay={OverlayTooltip}>
          {children as JSX.Element}
        </OverlayTrigger>
      ) : (
        <div>{children}</div>
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tooltip, placement]
  )

  return (
    <Wrapper>
      <div
        role={copy ? 'button' : undefined}
        onClick={copy ? handleCopy : undefined}
        className={`d-inline-block ${className}`}>
        {children}
      </div>
    </Wrapper>
  )
}
